import { initTooltips } from "./util.js";
initTooltips();

const categories = document.querySelectorAll("button[category]");
const cards = document.querySelectorAll("[card]");

categories.forEach((category) => {
  category.addEventListener("click", (e) => {
    // Set category as active
    const active = document.querySelector("button.active");
    if (active) active.classList.remove("active");
    category.classList.add("active");

    // Get data key from e
    const key = e.target.dataset.key;

    // Go through all cards
    cards.forEach((card) => {
      // If card is not in the category, hide it
      if (!card.getAttribute("category").includes(key)) {
        card.classList.add("d-none");
      } else {
        card.classList.remove("d-none");
      }
    });

    // If key is all, then show all cards
    if (key === "all") {
      cards.forEach((card) => {
        card.classList.remove("d-none");
      });
    }
  });
});

// Get all card links
const allCardLinks = document.querySelectorAll("a.card-link");
const tryRandom = document.querySelector("#tryRandom");
const showFavourites = document.querySelector("#showFavourites");
const sortRandom = document.querySelector("#sortRandom");
const cardGrid = document.getElementById("cardGrid");

// If sort random, sort all cards randomly
sortRandom.addEventListener("click", () => {
  console.log("Sorting cards randomly");

  // Get all cards
  const allCards = [...document.querySelectorAll("[card]")];

  // Check if there are any cards to sort
  if (allCards.length === 0) {
    console.log("No cards to sort");
    return;
  }

  // Get all cards and shuffle them
  const shuffledCards = shuffleArray(allCards);

  // Remove all cards
  allCards.forEach((card) => card.remove());

  // Add shuffled cards to DOM
  shuffledCards.forEach((card) => {
    cardGrid.appendChild(card);
  });

  // Shuffle an array using the Fisher-Yates algorithm
  function shuffleArray(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
});

// If try random, pick random link and redirect
tryRandom.addEventListener("click", (event) => {
  event.preventDefault();

  if (allCardLinks.length === 0) {
    console.log("No links to choose from");
    return;
  }

  try {
    const randomLink = allCardLinks[Math.floor(Math.random() * allCardLinks.length)];
    window.location.href = randomLink.href;
  } catch (e) {
    console.log(e);
  }
});

addSearchFunctionality();
function addSearchFunctionality() {
  try {
    const search = document.querySelector("#search");
    if (!search) return;

    search.addEventListener("keyup", (e) => {
      const searchValue = e.target.value.toLowerCase();

      // Go through all cards
      cards.forEach((card) => {
        if (!card) return;

        let cardCategory, cardTitle, cardUrl, cardSubtitle;
        try {
          // If lowercased card category, URL or title does not INCLUDE search value, hide it.
          cardCategory = card.getAttribute("category").toLowerCase();
          cardTitle = card.querySelector("h2")?.textContent?.toLowerCase();
          cardUrl = card.querySelector("a").href?.toLowerCase();
          cardSubtitle = card.querySelector("p.card-text").textContent?.toLowerCase();
        } catch (e) {
          console.log(e);
        }

        if (!cardCategory.includes(searchValue) && !cardTitle.includes(searchValue) && !cardUrl.includes(searchValue) && !cardSubtitle.includes(searchValue)) {
          card.classList.add("d-none");
        } else {
          card.classList.remove("d-none");
        }
      });
    });
  } catch (e) {
    console.log(e);
  }
}

addFavourites();
function addFavourites() {
  // Get star attribute
  const starBtns = document.querySelectorAll("[star]");
  if (!starBtns) return;

  // Add event listener to each star
  starBtns.forEach((starBtn) => {
    starBtn.addEventListener("click", (e) => {
      e.preventDefault();
      console.log("click", e.target);
      if (starBtn.getAttribute("favourite") === "false") {
        starBtn.setAttribute("favourite", "true");
        starBtn.innerHTML = `<i class="bi bi-star-fill"></i>`;
      } else {
        starBtn.setAttribute("favourite", "false");
        starBtn.innerHTML = `<i class="bi bi-star"></i>`;
      }

      // Update favourites array -- get all set as true
      const favourites = [];
      const favouritedStarBtns = document.querySelectorAll("button[favourite=true]");

      // Get h4 in the same card as the favourited star btn
      favouritedStarBtns.forEach((favouritedStarBtn) => {
        const card = favouritedStarBtn.closest("[card]");
        console.log({ card });
        const cardTitle = card.querySelector("h2").textContent;
        favourites.push(cardTitle);
      });

      // Save in Local Storage
      localStorage.setItem("favourites", favourites.join(","));
    });
  });

  // On load, get favourites
  const favourites = localStorage.getItem("favourites");
  if (!favourites) return;

  // Split favourites
  const favouritesArray = favourites.split(",");
  console.log({ favouritesArray });

  // Go through all cards
  cards.forEach((card) => {
    // If card title is in favourites array, set star to true
    const cardTitle = card.querySelector("h2").textContent;
    if (favouritesArray.includes(cardTitle)) {
      console.log("No", favouritesArray, cardTitle);
      const starBtn = card.querySelector("[star]");
      starBtn.setAttribute("favourite", "true");
      starBtn.innerHTML = `<i class="bi bi-star-fill"></i>`;
    }
  });
}

// A button to Show only favourites
showFavourites.addEventListener("click", () => {
  showFavourites.classList.toggle("active");
  if (showFavourites.classList.contains("active")) {
    showFavourites.innerText = "Vis alle";
  } else {
    showFavourites.innerText = "Vis favoritter";
  }

  cards.forEach((card) => {
    // If card is not a favourite, hide it
    const starBtn = card.querySelector("[star]");

    // if .active, show only favourites
    if (showFavourites.classList.contains("active")) {
      if (starBtn.getAttribute("favourite") === "false") {
        card.classList.add("d-none");
      } else {
        card.classList.remove("d-none");
      }
    } else {
      card.classList.remove("d-none");
    }
  });
});
